import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function HardHungryIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M7.87909 30.4005H24.7008C28.3456 27.8634 30.6325 23.8618 30.98 19.4734H24.8526L21.2914 23.037L17.7302 19.4734H1.60001C1.94745 23.8618 4.23434 27.8634 7.87909 30.4005Z"
        fill="currentColor"
      />
      <path
        d="M11.8412 17.1282L16.289 12.6803L20.7368 17.1282L24.0531 13.812L19.6051 9.36411L24.0531 4.91627L20.7368 1.6L16.289 6.04792L11.8412 1.6L8.52499 4.91627L12.9729 9.36411L8.52499 13.812L11.8412 17.1282Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
